// Autogenerated file
export const sensorTypesEnum = {
    DieselFuelLevel: "DieselFuelLevel",
    GasFuelLevel: "GasFuelLevel",
};
export const sensorTypes = [
    { label: "Датчик уровня топлива (Дизель)", value: "DieselFuelLevel" },
    { label: "Датчик уровня топлива (Газ)", value: "GasFuelLevel" },
];
